import { ref } from 'vue';

import { memoize } from '@/helpers/memoize/memoize';
import { fetchGeo, Geo } from '@/services/geolocation';

export function useCountry() {
  const country = ref<Geo>();
  const isLoaded = ref(false);

  async function load() {
    try {
      country.value = await memoize(fetchGeo)();
      return country.value;
    } finally {
      isLoaded.value = true;
    }
  }

  return {
    country,
    isLoaded,
    load,
  };
}
